import { render, staticRenderFns } from "./LegalUnitsPopup.vue?vue&type=template&id=a178ddaa&"
import script from "./LegalUnitsPopup.vue?vue&type=script&lang=js&"
export * from "./LegalUnitsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a178ddaa')) {
      api.createRecord('a178ddaa', component.options)
    } else {
      api.reload('a178ddaa', component.options)
    }
    module.hot.accept("./LegalUnitsPopup.vue?vue&type=template&id=a178ddaa&", function () {
      api.rerender('a178ddaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entities/LegalUnitsPopup.vue"
export default component.exports